import { render } from "./SessionContent.vue?vue&type=template&id=40423367&bindings={\"classroom\":\"props\",\"session\":\"props\",\"flash\":\"props\",\"content\":\"props\",\"course_content\":\"props\",\"isMainContent\":\"data\",\"bulkImportIds\":\"data\",\"selectedRecord\":\"data\",\"isLive\":\"data\",\"handleFileUploadSubmit\":\"options\",\"formatBytes\":\"options\",\"showImportContentModal\":\"options\",\"markForImport\":\"options\",\"importCourseData\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"updateLiveStatus\":\"options\"}"
import script from "./SessionContent.vue?vue&type=script&lang=js"
export * from "./SessionContent.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "40423367"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40423367')) {
    api.reload('40423367', script)
  }
  
  module.hot.accept("./SessionContent.vue?vue&type=template&id=40423367&bindings={\"classroom\":\"props\",\"session\":\"props\",\"flash\":\"props\",\"content\":\"props\",\"course_content\":\"props\",\"isMainContent\":\"data\",\"bulkImportIds\":\"data\",\"selectedRecord\":\"data\",\"isLive\":\"data\",\"handleFileUploadSubmit\":\"options\",\"formatBytes\":\"options\",\"showImportContentModal\":\"options\",\"markForImport\":\"options\",\"importCourseData\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"updateLiveStatus\":\"options\"}", () => {
    api.rerender('40423367', render)
  })

}

script.__file = "resources/js/Pages/AssignedClassrooms/Classroom/SessionContent.vue"

export default script